import React from "react";
import { ListResponse } from "src/types";

import { fetchAllEvents, FetchAllEventsPayload } from "@admin/api/event";
import { showErrorToast } from "@shared/toasts/Toasts";

import { EventReport } from "../../dashboard/devices/types";

export const useGetAllEvents = (payload: FetchAllEventsPayload = {}) => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState<ListResponse<EventReport>>({
        list: [],
        count: 0,
        message: "",
    });

    React.useLayoutEffect(() => {
        let isStale = false;
        setIsLoading(true);

        void fetchAllEvents(payload)
            .then((response) => {
                if (!isStale) {
                    setData(response);
                }
            })
            .catch((error) => {
                if (isStale) {
                    return;
                }
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => {
                if (!isStale) {
                    setIsLoading(false);
                }
            });

        return () => {
            isStale = true;
        };
    }, [
        payload.pageIndex,
        payload.pageSize,
        payload.levels,
        payload.workspaceIds,
        payload.groupIds,
        payload.entityIds,
        payload.categories,
        payload.createdFrom,
        payload.createdTo,
        payload.searchTerm,
        payload.sortCriteria,
        payload.sortDirection,
    ]);

    return { data, isLoading };
};
